








///////////
///////////////////
/////////
import GLApp from "@/webgl/index";
//////////
import { Vue, Component, Emit } from 'nuxt-property-decorator';

@Component
export default class GLView extends Vue {

  loaded = false
  isdestroyed = false

  viewer!: GLApp


  mounted(): void {
    this.isdestroyed = false

    this.viewer = GLApp.getInstance()
    this.viewer.load().then( this.onLoaded )

    this.$el.appendChild( this.viewer.glview.canvas )

  }

  destroyed():void{
    this.isdestroyed = true
    this.viewer.stop()
  }

  @Emit('loaded')
  onLoaded(): void {
    if( this.isdestroyed ) return
    this.viewer.start()
    this.loaded = true
    
  }


}

if(module.hot){
  module.hot.decline();
}

